export type MarketingConsentHeaderSource = {
  header_image_url?: string | null;
  assets?: { url: string }[] | null;
  consent_text?: string | null;
};

/** Resolve the banner image for the marketing consent modal header. */
export function resolveMarketingConsentHeaderUrl(
  consent: MarketingConsentHeaderSource | null | undefined
): string | null {
  if (!consent) return null;

  const headerUrl = consent.header_image_url?.trim();
  if (headerUrl) return headerUrl;

  const assetUrl = consent.assets?.find(asset => asset.url?.trim())?.url?.trim();
  if (assetUrl) return assetUrl;

  const consentText = consent.consent_text ?? '';
  const inlineMatch = consentText.match(/<img[^>]+src=["']([^"']+)["']/i);
  if (inlineMatch?.[1]) return inlineMatch[1];

  return null;
}
